import RegistrationSurveyUserSecond from "./RegistrationSurveyUserSecond";
export default RegistrationSurveyUserSecond